
import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Router } from '@angular/router';
import { UtilitiesService } from '../services/utilities.service';
import { UserService } from '../services/user.service';
import { NotificationService } from '../services/notification.service';
import { BsModalRef } from 'ngx-bootstrap';
import { Subscription } from 'rxjs';
import swal from 'sweetalert2';

@Component({
  selector: 'app-form-reconnect',
  templateUrl: './form-reconnect.component.html',
  styleUrls: ['./form-reconnect.component.scss']
})
export class FormReconnectComponent implements OnInit {

  busyConnecte : Subscription;
  user : any = {};
  itemToSave : any = {};
  currentUser : any = {};

   constructor(public router: Router,private notificationService : NotificationService,private api:ApiService,private utilities : UtilitiesService,public bsModalRef: BsModalRef,private userService: UserService) { 
      setTimeout(() => {
        this.user  = Object.assign({},this.currentUser);
      }, 700);
   }

  
  login(item)
  {
    console.log("le item",item);
    item.showLoader = true;
    item.login = this.user.login;
    if(!item  || !item.password)
    {
      item.showLoader = false;
      this.notificationService.showMessageError("Erreur","Veuillez renseigner les champs obligatoires.");
      return;
    }
    
    var request = {
      //user : "1",
      "data":
        {
          "login": item.login,
          "password": item.password,
          "action" : "Connexion",
          "source":"Web",
          "referenceSource":  navigator.userAgent 
        } 
     }

     this.busyConnecte = this.api.post('user/login', request)
          .subscribe(
              res => {
                  console.log('get user',res); 
                  item.showLoader = false;
                  if(!res['hasError'] && res['items'])
                  {
                    var currentUser = res['items'][0];
                    //localStorage.setItem("yz-backoffice-app-boutique-shell",JSON.stringify(currentUser));

                    if(currentUser && currentUser.fonctionnalites && currentUser.fonctionnalites.length > 0)
                    {
                      currentUser.fonctionnalites.push({code : "DASH",libelle : 'DASHBORD'});
                    }

                    localStorage.setItem("yz-backoffice-app-oneci-sms",JSON.stringify(res['items'][0])); 
                    this.bsModalRef.hide();
                  }
                  else
                  {
                    this.notificationService.showMessageError("Connexion", this.utilities.mainSelfFormatMsgServeur(res['status']['message']));
                  }
              },
              err => {
                  console.log("Error occured G",err);
                  item.showLoader = false;
              }
          );

    }

    closeSession()
    {
    
        swal({
          title: 'Fermerture de session',
          text: 'Désirez-vous poursuivre cette action ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Oui',
          cancelButtonText: 'Non',
          confirmButtonColor: "#ff7512",
          cancelButtonColor: "rgb(154, 154, 153)",
        }).then((result) => {
          if (result) {
            this.router.navigate(['/auth']);
            this.bsModalRef.hide();
            document.location.reload(true);
          } else {
            //console.log("bnjr");
          }
        })

    }


    ngOnInit() {
    }

}
